import { createContext, useContext } from "react";
export const FlavourCarouselContext = createContext({
    isInversed: false,
});
export const FlavourCarouselSlide = createContext({});
export const useFlavourCarousel = () => {
    return useContext(FlavourCarouselContext);
};
//# sourceMappingURL=FlavourCarouselContext.js.map